/* File: assets/featured-products-custom.js */
document.addEventListener('DOMContentLoaded', () => {
  /*
    Note: Elixira's native product-form.js controls the AJAX cart injection logic.
    Because our form leverages the exact `<product-form>` component structure,
    it natively binds to Elixira without custom fetch interceptions.
    
    This guarantees 100% synchronization with your Cart Drawer and Bubbles.
  */
});